export const PEACEFLAME_REGISTER_FIRST_NAME_KEY = 'pf_register_first_name';
export const PEACEFLAME_REGISTER_SOURCE_KEY = 'pf_register_source';
export const PEACEFLAME_REGISTER_SOURCE = 'peaceflame';

export function getPeaceFlameSourceUrl(path: string): string {
  return `${path}?source=${PEACEFLAME_REGISTER_SOURCE}`;
}

export function setPeaceFlameRegisterPending(firstName?: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(
      PEACEFLAME_REGISTER_SOURCE_KEY,
      PEACEFLAME_REGISTER_SOURCE
    );
    if (firstName) {
      window.sessionStorage.setItem(
        PEACEFLAME_REGISTER_FIRST_NAME_KEY,
        firstName
      );
    }
  } catch {
    /* storage unavailable: backend sign-in still carries the name */
  }
}

export function getPeaceFlameRegisterPendingSource(): string {
  if (typeof window === 'undefined') return '';
  try {
    return (
      window.sessionStorage.getItem(PEACEFLAME_REGISTER_SOURCE_KEY)?.trim() ||
      ''
    );
  } catch {
    return '';
  }
}

export function clearPeaceFlameRegisterPending(): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(PEACEFLAME_REGISTER_SOURCE_KEY);
  } catch {
    /* storage unavailable */
  }
}
